/**
 * Utilities for the OffsetDateTimeDTO.
 */
define(['./Instant'], (Instant) => ({
    /**
     * Creates a new instance of offsetDateTime DTO capturing a local UTC time offset from the date (based on current
     * client TZ rules.
     */
    fromJSDate(date) {
        return date ? {instant: Instant.fromJSDate(date), offset: -date.getTimezoneOffset()} : date;
    },


    /**
     * Converts a DTO into a local date. The returned date represents correct instant but originating time offest
     * is lost.
     */
    toLocalDate(dto) {
        return dto ? Instant.toJSDate(dto.instant) : dto;
    }
}));


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/time/OffsetDateTime.js
 **/